export const supportFr = {
    frequentlyAsked: 'Questions fréquentes',
    results: 'Résultats correspondants',
    yourQuestion: 'Posez votre question ici'
}
